import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  topContainer: {padding: 32},
  inputRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 16,
    alignItems: 'flex-end',
  },
};

export default styles;
